import React, { useState } from "react";

function FileUpload({ onUpload }) {
  const [previewName, setPreviewName] = useState(null);

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setPreviewName(file.name);

    onUpload(file);
  };

  return (
    <div className="form-group full-width file-upload-section">
      <div className="file-upload-left">
        <label>Upload Supporting Document:</label>
        <input
          type="file"
          name="supportingDocuments"
          accept=".pdf, .jpg, .jpeg, .png, .doc, .docx"
          onChange={handleFile}
        />

        <small className="file-hint">
          Supported formats: PDF, JPG, PNG, DOC, DOCX
        </small>

        {previewName && <p className="file-preview">Selected: {previewName}</p>}
      </div>
    </div>
  );
}

export default FileUpload;
